import moment from 'moment-timezone';
import React, { Component } from 'react';
import { DateFormat, EventActionViewModel } from 'stageclip-common';

import { PageTitle } from '../pages/pageTitle';
import { ActionLogDetailsModal } from '../actionLogDetailsModal/ActionLogDetailsModal';

import { AppTableColumn } from 'components/table/appTable';
import { callApi } from 'helpers/callApi/callApi';
import Button from 'components/buttons/button';
import { MailerLogTableOwnProps, MailerLogTableStateProps } from './MailerLogTable.types';
import { Table } from './table/Table';

export class MailerLogTable extends Component<MailerLogTableOwnProps, MailerLogTableStateProps> {
  columns: AppTableColumn[] = [
    {
      Header: 'Action',
      accessor: (a: EventActionViewModel) => a.action,
      id: 'action',
    },
    {
      Header: 'Event id',
      accessor: (a: any) => a.event.id,
      id: 'eventId',
    },
    {
      Header: 'Timestamp',
      accessor: (a: EventActionViewModel) => moment(a.timestamp).format(DateFormat.DateTime),
      id: 'timestamp',
    },
    {
      Header: 'Status',
      accessor: (a: any) => (a.success ? 'success' : 'error'),
      id: 'status',
    },
    {
      Cell: ({ value }: { value: EventActionViewModel }) => {
        const { openDetails } = this.props;
        const { data, action, timestamp } = value;

        return data ? <Button onClick={() => openDetails({ data, action, timestamp })} text="Details" /> : '-';
      },
      Header: 'Details',
      accessor: (event: EventActionViewModel) => event,
      id: 'details',
    },
  ];

  constructor(props: any) {
    super(props);

    this.state = {
      data: undefined,
      error: false,
      pagination: null,
      pageSize: 20,
      page: 1,
      loading: false,
    };
  }

  componentDidMount(): void {
    const { page, pageSize } = this.state;

    this.getData(page, pageSize);
  }

  componentDidUpdate(prevProps: Readonly<MailerLogTableOwnProps>, prevState: Readonly<MailerLogTableStateProps>): void {
    const { pageSize, page } = this.state;

    if (prevState.pageSize !== pageSize || prevState.page !== page) {
      this.getData(page, pageSize);
    }
  }

  getData(page: number, pageSize: number) {
    this.setState({ loading: true });
    const { fetchEmailsLog } = this.props;

    callApi({
      action: () => fetchEmailsLog({ page, pageSize }),
      onSuccess: (response: any) => {
        this.setState({ data: response.result.rows, pagination: response.result.paginationMeta, loading: false });
      },
      onFailure: () => {
        this.setState({ error: true, data: [], loading: false });
      },
    });
  }

  handleChangePagination = (page: number) => {
    this.setState({ page: page + 1 });
  };

  handleChangePageSize = (pageSize: number) => {
    this.setState({ page: 1, pageSize });
  };

  render() {
    const { data, error, pagination, loading } = this.state;

    return (
      <>
        <PageTitle displayTitle="Mailer log" />
        {error && <div>Something went wrong</div>}
        <Table
          emails={data}
          loading={loading}
          pagination={pagination}
          changePagination={this.handleChangePagination}
          changePageSize={this.handleChangePageSize}
          columns={this.columns}
        />
        <ActionLogDetailsModal />
      </>
    );
  }
}
